import { useNavigate } from 'react-router-dom';

/**
 * Fallback affiché si sessionStorage['evalPrintData'] est vide
 * (refresh manuel, lien direct, etc.).
 */
const EmptyState = () => {
    const navigate = useNavigate();
    return (
        <div className="ep-empty">
            <h1 className="ep-empty-title">Aucune évaluation à imprimer</h1>
            <p className="ep-empty-text">
                Les données de l'évaluation n'ont pas été trouvées.
                Cela peut arriver si tu as rechargé la page ou ouvert ce lien directement.
            </p>
            <button
                type="button"
                className="ep-empty-cta"
                onClick={() => navigate('/home/')}
            >
                Retour à la sélection
            </button>
        </div>
    );
};

export default EmptyState;
